import axios from 'axios';

const adhocBackend = 'https://adhocstudio.ca/feed/getSections.php';

export default {
  fetchSectionData(projectId) {
    return axios.get(`${adhocBackend}?id=${projectId}`);
  }
};



// WEBPACK FOOTER //
// ./src/services/project.js